import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import {
  IBlockTimeItem,
  ISplitBlockTimeRecordPayload,
  ISplittedBlockTimeRecordViewModel,
} from 'src/app/ReusableComponent/block-time-report/block-time-report.model';
import { ReportService } from 'src/app/service/report.service';
import {
  ISplitRecordDefaultFieldsViewModel,
  ISplitRecordPopupDataViewModel,
  ISplittedCustomerViewModel,
} from './split-record-dialog.model';
import { SplitRecordDialogService } from './split-record-dialog.service';

@Component({
  selector: 'app-split-record-dialog',
  templateUrl: './split-record-dialog.component.html',
  styleUrls: ['./split-record-dialog.component.css'],
})
export class SplitRecordDialogComponent implements OnInit {
  loader: boolean = false;
  isShowSplitRecordTableSpinnerLoader: boolean = false;
  fieldDisplayNameWithDateValue = ['Date']; //Used to identify the fields with date values
  splitRecordDefaultFields: ISplitRecordDefaultFieldsViewModel[] = [
    {
      fieldDisplayName: 'Date',
      id: 'date_field',
      mappingName: 'srCreatedOnDate',
      value: '',
    },
    {
      fieldDisplayName: 'Trip #',
      id: 'tripId_field',
      mappingName: 'tripID',
      value: '',
    },
    {
      fieldDisplayName: 'Customer',
      id: 'customer_field',
      mappingName: 'customerName',
      value: '',
    },
    {
      fieldDisplayName: 'SR Type',
      id: 'srType_field',
      mappingName: 'serviceTypeName',
      value: '',
    },
    {
      fieldDisplayName: 'Organ Type',
      id: 'organType_field',
      mappingName: 'jobTypeName',
      value: '',
    },
    {
      fieldDisplayName: 'Ground Vendor',
      id: 'groundVendor_field',
      mappingName: 'vendorName',
      value: '',
    },
    {
      fieldDisplayName: 'Unos ID',
      id: 'unosId_field',
      mappingName: 'unosid',
      value: '',
    },
    {
      fieldDisplayName: 'Air Vendor',
      id: 'airVendor_field',
      mappingName: 'vendorName',
      value: '',
    },
    {
      fieldDisplayName: 'OB Repo',
      id: 'obRepo_field',
      mappingName: 'outboundReposition',
      value: '',
    },
    {
      fieldDisplayName: 'OB Est. Block Hours',
      id: 'obEstimated_blockHours_field',
      mappingName: 'obEstimatedBlockHours',
      value: '',
    },
    {
      fieldDisplayName: 'Routing',
      id: 'routing_field',
      mappingName: 'routing',
      value: '',
    },
    {
      fieldDisplayName: 'IB Repo',
      id: 'ibRepo_field',
      mappingName: 'airportCode',
      value: '',
    },
    {
      fieldDisplayName: 'IB Est. Block Hours',
      id: 'ibEstimated_blockHours_field',
      mappingName: 'ibEstimatedBlockHours',
      value: '',
    },
    {
      fieldDisplayName: 'Tail #',
      id: 'tailNumber_field',
      mappingName: 'tailNumber',
      value: '',
    },
  ];
  splitRecordTableColumns: string[] = ['Direction', 'Origin', 'Destination', 'Driver', 'Customer'];
  splittedBlockTimeRecordList: ISplittedBlockTimeRecordViewModel[] = [];
  customerListDropdownSetting = {
    singleSelection: true,
    idField: 'customerID',
    textField: 'customerName',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: ISplitRecordPopupDataViewModel,
    private _datePipe: DatePipe,
    private _reportService: ReportService,
    private _toaster: ToastrService,
    private _matDialogRef: MatDialogRef<SplitRecordDialogComponent>,
    public splitRecordDialogService: SplitRecordDialogService,
  ) {}

  ngOnInit(): void {
    this.setBlockTimeRecordDefaultFieldValues(this.dialogData.blocktimeRecord);
    this.getBolckTimeRecordToSplit();
  }

  setBlockTimeRecordDefaultFieldValues(record: IBlockTimeItem) {
    this.splitRecordDefaultFields.forEach((recordField) => {
      /**
       * The fieldDisplayNameWithDateValue is used to check the fields with date values to apply the date pipes.
       */
      if (this.fieldDisplayNameWithDateValue.includes(recordField.fieldDisplayName)) {
        recordField.value = this._datePipe.transform(record[recordField.mappingName], 'MM-dd-yyyy');
      } else {
        switch (recordField.fieldDisplayName) {
          case 'Customer':
            recordField.value = record.customer[recordField.mappingName];
            break;
          case 'SR Type':
            recordField.value = record.serviceType;
            break;
          case 'jobTypeName':
            recordField.value = record.primaryOrgan[recordField.mappingName];
            break;
          case 'Organ Type':
            recordField.value = record.additionalOrgans;
            break;
          case 'Air Vendor':
            recordField.value = record.airVendor;
            break;
          case 'Ground Vendor':
            recordField.value = record.groundVendor;
            break;
          case 'OB Repo':
            recordField.value = record.outboundReposition;
            break;
          case 'IB Repo':
            recordField.value = record.inboundReposition;
            break;
          case 'aircraftType':
            recordField.value = record.aircraftType;
            break;
          case 'aircraftSize':
            recordField.value = record.aircraftSize;
            break;
          default:
            recordField.value = record[recordField.mappingName];
            break;
        }
      }
    });
  }

  getBolckTimeRecordToSplit() {
    this.isShowSplitRecordTableSpinnerLoader = true;
    const payloadToGetSplittedRecords = {
      tripId: this.dialogData.blocktimeRecord.tripID,
      tailNumber: this.dialogData.blocktimeRecord.tailNumber,
    };
    this._reportService.getBlockTimeRecordToSplit(payloadToGetSplittedRecords.tripId, payloadToGetSplittedRecords.tailNumber).subscribe(
      (response) => {
        this.isShowSplitRecordTableSpinnerLoader = false;
        this.splittedBlockTimeRecordList = !response ? [] : response;
        this.prepareSplittedRecord(this.splittedBlockTimeRecordList);
      },
      () => {
        this.isShowSplitRecordTableSpinnerLoader = false;
        this._toaster.warning('Something went wrong while getting splitted record list!', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  prepareSplittedRecord(splittedRecordList: ISplittedBlockTimeRecordViewModel[]) {
    splittedRecordList.forEach((record) => {
      record.customer = [this.dialogData.blocktimeRecord.customer[0]];
    });
    this.isRecordsValidToSplit(false);
  }

  splitBlockTimeRecord() {
    this.isRecordsValidToSplit(true);
    if (this.splitRecordDialogService.isValidToSplit && confirm('Do you want to split the record?')) {
      this.loader = true;
      const splitBlockTimeRecordPayload: ISplitBlockTimeRecordPayload = {
        blockTimeRecord: this.dialogData.blocktimeRecord,
        splittedRecordList: this.splittedBlockTimeRecordList,
      };
      this._reportService.splitBlockTimeRecord(splitBlockTimeRecordPayload).subscribe(
        (response) => {
          if (response) {
            this.loader = false;
            this.splitRecordDialogService.success('Record splitted successfully!');
            this._reportService.filterBlockTimeReportData.next(null);
            this._matDialogRef.close();
          } else {
            this.loader = false;
            this.splitRecordDialogService.warning('Something went wrong while splitting blocktime report!');
          }
        },
        () => {
          this.loader = false;
          this.splitRecordDialogService.warning('Something went wrong while splitting blocktime report!');
        },
      );
    }
  }

  isRecordsValidToSplit(isShowToasterMessage?: boolean) {
    this.splitRecordDialogService.isBlockTimeRecordApplicableToSplit(
      this.splittedBlockTimeRecordList,
      this.dialogData.blocktimeRecord.customer[0],
      isShowToasterMessage,
    );
  }
}
